import {
  ADD_USER,
  DELETE_BULK_USERS,
  DELETE_USER,
  EDIT_USER,
  GET_USERS,
  SET_USER_DETAILS, USER_SET_CURRENT
} from "../../@jumbo/constants/ActionTypes";
import { USER_AFTER_LOGIN_SUCCESS } from "../action-types/UserActionTypes";
import { FETCH_TENANT_LIST_SUCCESS, UPDATE_CURRENT_USER_TENANT_SUCCESS } from "../action-types/TenantActionTypes";

const INIT_STATE = {
  users: [],
  currentUser: null,
  tenantList: []
};

export default (state = INIT_STATE, action) => {

  switch (action.type) {
    case GET_USERS: {
      return {
        ...state,
        users: action.payload,
      };
    }
    case SET_USER_DETAILS: {
      return {
        ...state,
        currentUser: action.payload,
      };
    }
    case USER_AFTER_LOGIN_SUCCESS: {
      return {
        ...state,
        currentUser: action.payload,
      };
    }
    case UPDATE_CURRENT_USER_TENANT_SUCCESS: {
      return {
        ...state,
        currentUser: action.payload,
      };
    }
    case FETCH_TENANT_LIST_SUCCESS: {
      return {
        ...state,
        tenantList: action.payload,
      };
    }
    case ADD_USER: {
      return {
        ...state,
        users: [action.payload, ...state.users],
      };
    }
    case EDIT_USER: {
      return {
        ...state,
        users: state.users.map(user => (user.id === action.payload.id ? action.payload : user)),
      };
    }
    case DELETE_USER: {
      return {
        ...state,
        users: state.users.filter(user => user.id !== action.payload),
      };
    }
    case DELETE_BULK_USERS: {
      return {
        ...state,
        users: state.users.filter(user => !action.payload.includes(user.id)),
      };
    }
    case USER_SET_CURRENT: {

      return {
        ...state,
        currentUser: { ...state.currentUser, user: action.payload }
      };
    }
    default:
      return state;
  }
};
